import { useMemo } from 'react';

import { RadioOrSelectOption } from '../../types/common.types';

import { timeOptions } from '../../utils/constants';
import { convertTimeStringToDate, mapStringOptionsToObjectOptions } from '../../utils/util';

const useTimeOptions = (startTime?: string, endTime?: string): [RadioOrSelectOption[], RadioOrSelectOption[]] => {
  return useMemo(() => {
    const copyOfTimeOptions = [...timeOptions];

    let filteredStartTimeOptions = copyOfTimeOptions;
    if (endTime) {
      filteredStartTimeOptions = copyOfTimeOptions.filter((timeOption) => {
        const timeOptionDate = new Date(convertTimeStringToDate(timeOption));
        const endTimeDate = new Date(convertTimeStringToDate(endTime));

        if (!timeOptionDate || !endTimeDate) return false;

        return timeOptionDate < endTimeDate;
      });
    }

    let filteredEndTimeOptions = copyOfTimeOptions;
    if (startTime) {
      filteredEndTimeOptions = copyOfTimeOptions.filter((timeOption) => {
        const timeOptionDate = new Date(convertTimeStringToDate(timeOption));
        const startTimeDate = new Date(convertTimeStringToDate(startTime));

        if (!timeOptionDate || !startTimeDate) return false;

        return timeOptionDate > startTimeDate;
      });
    }

    return [
      mapStringOptionsToObjectOptions(filteredStartTimeOptions),
      mapStringOptionsToObjectOptions(filteredEndTimeOptions)
    ];
  }, [startTime, endTime]);
};

export default useTimeOptions;
